var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import $request from '../../../utils/request';
var state = {
    isTenantCodeListLastFetchId: 0,
    tenantCodeListLoading: false,
    tenantCodeList: [],
    isLoanOrder: '',
    loanOrderList: [],
    totalItemCount: 0,
    pageSize: 20,
    pageNo: 1,
};
var mutations = {
    update: function (state, props) {
        for (var key in props) {
            if (state.hasOwnProperty(key)) {
                state[key] = props[key];
            }
        }
    },
};
var actions = {
    // 判断是否存在放款订单
    IS_LOAN_ORDER: function (_a) {
        var commit = _a.commit;
        $request({
            url: '/proxy/fund-api/capital/contract/exist',
            method: 'post',
        }).then(function (res) {
            if (!res) {
                return;
            }
            if (res.errorCode === 0) {
                commit('update', {
                    isLoanOrder: res.data ? 2 : 1,
                });
            }
        });
    },
    // 获取放款订单列表
    GET_ORDERLIST: function (_a, param) {
        var commit = _a.commit;
        $request({
            url: '/proxy/fund-api/capital/contract/list/employer',
            method: 'post',
            data: param,
        }).then(function (res) {
            if (!res || res.errorCode !== 0) {
                return;
            }
            var data = res.data, totalItemCount = res.totalItemCount, pageSize = res.pageSize, pageNo = res.pageNo;
            commit('update', {
                loanOrderList: data,
                totalItemCount: totalItemCount,
                pageSize: pageSize,
                pageNo: pageNo,
            });
        });
    },
    GET_TENANTLIST: function (_a, param) {
        var commit = _a.commit;
        commit('update', {
            isTenantCodeListLastFetchId: state.isTenantCodeListLastFetchId++,
            tenantCodeList: [],
            tenantCodeListLoading: true,
        });
        var fecthId = state.isTenantCodeListLastFetchId;
        $request({
            method: 'POST',
            url: '/proxy/fund-api/capital/contract/capital/tenant',
            data: __assign({}, param),
            loadingControl: 'hand',
        }).then(function (res) {
            if (state.isTenantCodeListLastFetchId !== fecthId) {
                return;
            }
            if (!res) {
                commit('update', {
                    tenantCodeListLoading: false,
                    isTenantCodeListLastFetchId: 0,
                });
                return;
            }
            if (res.errorCode === 0) {
                var data = res.data || [];
                // TODO: 需要等待后台字段，更改其值
                var list = data.map(function (item) {
                    item.value = item.tenantCode;
                    item.label = item.tenantName;
                    return item;
                });
                commit('update', {
                    tenantCodeList: list,
                    tenantCodeListLoading: false,
                    isTenantCodeListLastFetchId: 0,
                });
            }
        });
    },
};
export default {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
};
